(() => {
  const TELEMETRY_URL = 'https://ankon-agency.app.n8n.cloud/webhook/larryvsharry-combeenation-telemetry';
  const STORAGE_KEY = 'lvh:combeenation-error';
  const TOAST_ID = 'lvh-combeenation-toast';
  const TOAST_FALLBACK = 'Something went wrong adding your build to the cart. Please try again, and contact us if it keeps happening.';
  const TOAST_AUTO_DISMISS_MS = 10000;

  function send(payload) {
    try {
      const body = new Blob([JSON.stringify(payload)], { type: 'text/plain;charset=UTF-8' });
      if (navigator.sendBeacon && navigator.sendBeacon(TELEMETRY_URL, body)) return;
    } catch (_) { /* fall through */ }
    try {
      fetch(TELEMETRY_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: JSON.stringify(payload),
        keepalive: true,
        mode: 'cors',
        credentials: 'omit',
      }).catch(() => {});
    } catch (_) { /* swallow */ }
  }

  function privacyModeEnabled() {
    try {
      return !!(window.Alpine && window.Alpine.store && window.Alpine.store('privacyMode') && window.Alpine.store('privacyMode').enabled);
    } catch (_) { return null; }
  }

  function parseShopifyError(detail) {
    const errorStatus = (detail && detail.error && detail.error.status) || null;
    const raw = detail && detail.error && detail.error.responseBody;
    if (!raw) return { status: errorStatus, shopifyMessage: null, shopifyDescription: null };
    try {
      const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
      return {
        status: parsed.status || errorStatus,
        shopifyMessage: parsed.message || null,
        shopifyDescription: parsed.description || null,
      };
    } catch (_) {
      return { status: errorStatus, shopifyMessage: null, shopifyDescription: null };
    }
  }

  function snapshot() {
    const theme = window.theme || {};
    return {
      ts: new Date().toISOString(),
      shop: (window.Shopify && window.Shopify.shop) || null,
      locale: (window.Shopify && window.Shopify.locale) || null,
      currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || null,
      href: window.location.href,
      pathname: window.location.pathname,
      referrer: document.referrer || null,
      userAgent: navigator.userAgent,
      viewport: { width: window.innerWidth, height: window.innerHeight },
      online: navigator.onLine,
      customer: theme.customer || null,
      b2b: theme.b2b || null,
      market: theme.market || null,
      privacyMode: privacyModeEnabled(),
    };
  }

  function getToastMessage() {
    try {
      return (window.theme && window.theme.strings && window.theme.strings.combeenationCartAddFailed) || TOAST_FALLBACK;
    } catch (_) {
      return TOAST_FALLBACK;
    }
  }

  function dismissToast(toast) {
    if (!toast) return;
    if (toast._dismissTimer) {
      clearTimeout(toast._dismissTimer);
      toast._dismissTimer = null;
    }
    toast.remove();
  }

  function showToast(message) {
    try {
      if (!document.body) return;
      let toast = document.getElementById(TOAST_ID);
      if (!toast) {
        toast = document.createElement('div');
        toast.id = TOAST_ID;
        toast.setAttribute('role', 'alert');
        toast.setAttribute('aria-live', 'assertive');
        Object.assign(toast.style, {
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: '2147483647',
          maxWidth: 'min(560px, calc(100vw - 32px))',
          padding: '18px 48px 18px 22px',
          background: '#1a1a1a',
          color: '#fff',
          fontSize: '15px',
          lineHeight: '1.45',
          borderRadius: '6px',
          boxShadow: '0 10px 40px rgba(0,0,0,0.35)',
          fontFamily: 'inherit',
          textAlign: 'center',
        });

        const msg = document.createElement('span');
        msg.className = 'lvh-combeenation-toast__message';
        toast.appendChild(msg);

        const closeBtn = document.createElement('button');
        closeBtn.type = 'button';
        closeBtn.setAttribute('aria-label', 'Close');
        closeBtn.textContent = '×';
        Object.assign(closeBtn.style, {
          position: 'absolute',
          top: '6px',
          right: '6px',
          width: '32px',
          height: '32px',
          border: '0',
          background: 'transparent',
          color: '#fff',
          fontSize: '22px',
          lineHeight: '1',
          cursor: 'pointer',
          opacity: '0.75',
          padding: '0',
        });
        closeBtn.addEventListener('click', () => dismissToast(toast));
        toast.appendChild(closeBtn);

        document.body.appendChild(toast);
      }
      toast.querySelector('.lvh-combeenation-toast__message').textContent = message;

      if (toast._dismissTimer) clearTimeout(toast._dismissTimer);
      toast._dismissTimer = setTimeout(() => dismissToast(toast), TOAST_AUTO_DISMISS_MS);
    } catch (_) { /* ignore */ }
  }

  window.addEventListener('combeenation:cart-error', (event) => {
    const detail = (event && event.detail) || {};
    const shopifyError = parseShopifyError(detail);
    const payload = {
      source: 'cart-error-event',
      status: shopifyError.status,
      shopifyMessage: shopifyError.shopifyMessage,
      shopifyDescription: shopifyError.shopifyDescription,
      detail,
      environment: snapshot(),
    };

    console.error('[combeenation] cart-error', detail);
    send(payload);
    showToast(getToastMessage());

    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
        message: detail.message || null,
        shopifyMessage: shopifyError.shopifyMessage,
        shopifyDescription: shopifyError.shopifyDescription,
        status: shopifyError.status,
        hint: detail.hint || null,
        operationId: (detail.context && detail.context.operationId) || null,
        at: Date.now(),
      }));
    } catch (_) { /* storage may be unavailable */ }
  });

  function matchesBuilderUrl(url) {
    if (!url) return null;
    let parsed;
    try { parsed = new URL(url, window.location.origin); } catch (_) { return null; }
    const path = parsed.pathname || '';
    if (!path.startsWith('/pages/')) return null;
    const lower = path.toLowerCase();
    if (!lower.includes('build') && !lower.includes('bike')) return null;
    return {
      url: parsed.href,
      origin: parsed.origin,
      pathname: path,
      handle: path.replace(/^\/pages\//, '').replace(/\/$/, ''),
    };
  }

  function readNavigationHistory(lookback) {
    try {
      const nav = window.navigation;
      if (!nav || typeof nav.entries !== 'function' || !nav.currentEntry) return null;
      const entries = nav.entries();
      if (!entries || !entries.length) return null;
      const currentIndex = nav.currentEntry.index;
      const out = [];
      const start = Math.max(0, currentIndex - lookback);
      for (let i = currentIndex - 1; i >= start; i--) {
        const entry = entries[i];
        if (!entry) continue;
        out.push({
          offset: i - currentIndex,
          url: entry.url || null,
          sameDocument: !!entry.sameDocument,
        });
      }
      return out;
    } catch (_) { return null; }
  }

  function detectBuilderRedirect() {
    try {
      const path = window.location.pathname || '';
      if (path !== '/cart' && path !== '/cart/') return;

      const navEntry = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || null;
      const navigationType = navEntry ? navEntry.type : null;
      if (navigationType === 'reload') return;

      const referrer = document.referrer || null;
      const referrerMatch = matchesBuilderUrl(referrer);

      const history = readNavigationHistory(5);
      const historyMatches = (history || [])
        .map((entry) => ({ ...entry, match: matchesBuilderUrl(entry.url) }))
        .filter((entry) => entry.match);

      if (!referrerMatch && historyMatches.length === 0) return;

      const matchedVia = [];
      if (referrerMatch) matchedVia.push('referrer');
      if (historyMatches.length) matchedVia.push('navigation-history');

      const payload = {
        source: 'cart-page-arrived-from-builder',
        matchedVia,
        primary: referrerMatch || historyMatches[0].match,
        referrer,
        referrerMatch,
        navigationApiAvailable: !!(window.navigation && typeof window.navigation.entries === 'function'),
        navigationHistory: history,
        historyMatches,
        navigationType,
        environment: snapshot(),
      };

      console.warn('[combeenation] cart-page-arrived-from-builder', payload);
      send(payload);
    } catch (_) { /* swallow */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', detectBuilderRedirect);
  } else {
    detectBuilderRedirect();
  }
})();
